import { FormattedMessage } from 'react-intl';

import Icon from '@components/text/Icon';
import Heading3 from '@components/typography/Heading3';
import styles from '@components/typography/Typography.module.css';
import { JourneyStatusEnum } from '@typing/Enums';
import { colorForStatus, iconForStatus } from '@utils/modelUtils';

type Props = {
  iconOnly?: boolean;
  status: JourneyStatusEnum;
};

const StatusText = ({ iconOnly = false, status }: Props) => {
  const statusesWithCustomIcon =
    status === JourneyStatusEnum.DRAFT ||
    status === JourneyStatusEnum.UNPUBLISHED_ITEMS ||
    status === JourneyStatusEnum.ARCHIVED ||
    status === JourneyStatusEnum.VIEWED;

  return (
    <div className={iconOnly ? '' : styles.statusText}>
      <Icon
        color={colorForStatus(status)}
        icon={statusesWithCustomIcon ? iconForStatus(status) : 'circleSolid'}
        size={statusesWithCustomIcon ? 'medium' : 'small'}
      />

      {!iconOnly && (
        <Heading3 bold color={status === JourneyStatusEnum.VIEWED ? 'secondary500' : 'neutral500'} noMargin>
          <FormattedMessage id={`models.status.${status}`} />
        </Heading3>
      )}
    </div>
  );
};

export default StatusText;
